// TODO: fix other branchs color
const theme = {
  colors: {
    primary: '#18417C',
    secondary: '#126A65',
    default: '#777777',
    white: '#ffffff',
    grey1: '#F5F5F5',
    grey2: '#F8F8F8',
    grey3: '#EBEBEB',
    grey4: '#E6E6E6',
    grey5: '#EFEFEF',
    grey6: '#706A6A',
    grey7: '#707070',
    grey8: '#505050',
    green1: '#5FC967',
    green8: '#659E94',
    green2: '#42928C',
    green3: '#43928C',
    green7: '#31837E',
    green4: '#146B66',
    green5: '#126263',
    green6: '#125E63',
    skyBlue: '#5BC0DE',
    blue1: '#275583',
    blue2: '#12495F',
    blue3: '#253977',
    blue4: '#12375C',
    blue5: '#12345E',
    blue6: '#245D96',
    blue7: '#C8D7E0',
    yellow1: '#E6A95B',
    orange1: '#DE8353',
    red1: '#BE5757',
    success: '#439064',
    red2: '#BC5050',
    red3: '#BD5858',
    info: '#5BC0DE',
    warning: '#DE8353',
    danger: '#BE5757'
  }
}

export default theme
